<div class="mt-3">
  <div class="row">
    <div class="col-md-10 w-100 mt-3">
      <h4 class="title"><i class="fa fa-briefcase" aria-hidden="true"></i> {{title | translate}}</h4>
    </div>
    <div class="col-md-2 mt-3 content-position-end">
      <button type="button"
              class="btn btn-outline-success font-weight-bold custom-button mw-180"
              *ngIf="hasAuthority('own:job:add')"
              (click)="openAddModal()">
        <i class="fa fa-plus"></i> {{ "BUTTON.ADD" | translate }}
      </button>
    </div>
  </div>
</div>
<div class="">
  <div class="form-inline row">
    <div class="col-md-3 m-right" *ngIf="hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">
        {{ "LABEL.PARTNER" | translate }}: </label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_SUPERADMIN)"
                class="form-control"
                [(ngModel)]="partnerSelected"
                (ngModelChange)="reloadJobs0()">
          <option *ngFor="let partner of partners" [ngValue]="partner">
            {{partner.name | translate}}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-3 m-right" *ngIf="hasRole(ROLE_PARTNER) || hasRole(ROLE_SUPERADMIN)">
      <label class="font-weight-bold">{{ "LABEL.ENTERPRISE" | translate }}:</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
        </div>
        <select *ngIf="hasRole(ROLE_PARTNER) || hasRole(ROLE_SUPERADMIN)"
                class="form-control"
                [(ngModel)]="enterpriseSelected"
                (ngModelChange)="reloadJobs()">
          <option *ngFor="let enterprise of enterprises"
                  [ngValue]="enterprise">{{ enterprise.name | translate }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="table-responsive mt-2 mb-2 custom-table-height">
    <table class="table-sm table-bordered">
      <thead>
      <tr>
        <th scope="col" title="#"></th>
        <th scope="col" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)"
            title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.DESCRIPTION' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.DATE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.STATE' | translate }}"></th>
        <th scope="col" title="{{'TABLE.HEADER.ACTION' | translate }}"></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let job of jobs; let index=index">
        <td title="#"><b>{{(page.number * pageNumber) + index + 1}}</b></td>
        <td title="{{ 'TABLE.HEADER.ENTERPRISE' | translate }}"
            *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">{{job._more.enterpriseName}}</td>
        <td title="{{'TABLE.HEADER.DESCRIPTION' | translate }}">{{job.description}}</td>
        <td title="{{'TABLE.HEADER.DATE' | translate }}">{{job.createAt | dateformat}}</td>
        <td title="{{'TABLE.HEADER.STATE' | translate }}">
        <span
          class="{{!job.active? 'badge badge-danger':''}}">{{job.active ? ('TABLE.HEADER.ACTIVE' | translate) : ('TABLE.HEADER.INACTIVE' | translate)}}</span>
        </td>
        <td title="{{'TABLE.HEADER.ACTION' | translate }}">
          <div class="dropdown">
            <a type="button" class="btn btn-default custom-content-position" id="dropdownMenuButton"
               data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              <i class="fa fa-ellipsis-v"></i>
            </a>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:job:edit')"
                      (click)="openModalEdit(job)">
                <i class="fa fa-pen"></i> {{ "BUTTON.EDIT" | translate }}
              </button>
              <button class="dropdown-item cursor-hover"
                      *ngIf="hasAuthority('own:job:delete')"
                      (click)="openModalDelete(job)">
                <i class="fa fa-trash"></i> {{ "BUTTON.DELETE" | translate }}
              </button>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <nav class="Page navigation pagination-custom">
    <div class="row">
      <div class="col-md-8 mt-1">
        <!--        <div>-->
        <div class="justify-content-row">
          <label class="mr-1">Mostrar </label>
          <select class="font-weight-bold br-6 form-control-sm" [(ngModel)]="pageNumber"
                  (ngModelChange)="loadJobs(enumPage.First)">
            <option *ngFor="let page of pageNumbers" [value]="page.value"
                    class="font-weight-bold">{{page.value}}</option>
          </select>
          <label class="ml-2 cmr-2"> registros.</label>
        </div>
        <!--        </div>-->
        <div class="fw-700 page-total-entries">
          {{ "LABEL.TOTAL-RECORDS" | translate }}
          : {{jobs.length + (page.number * page.size)}} {{ "LABEL.OF" | translate }} {{page.totalElements}}
        </div>
      </div>
      <div class="col-md-4">
        <ul class="pagination justify-content-end text-center">
          <li class="page-item btn-paged-ends cursor-pointer {{page.number === 0 ? 'disabled' : ''}}">
            <a class="prev {{page.number === 0 ? 'disabled' : ''}}" (click)="loadJobs(enumPage.First)"
               tabindex="-1" aria-disabled="true">
              <i class=" fa fa-angle-double-left" aria-hidden="true"></i>
              {{ "BUTTON.FIRST" | translate }}
            </a>
          </li>
          <li class="cursor-pointer {{page.number == 0 ? 'disabled' : ''}}">
            <a class="left" (click)="loadJobs(enumPage.Previous)">
              <i class="fa fa-angle-left" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}">
            <a class="right" (click)="loadJobs(enumPage.Next)"><i
              class="fa fa-angle-right" aria-hidden="true"></i></a>
          </li>
          <li class="cursor-pointer {{page.number === (page.totalPages - 1) || page.totalPages === 0 ? 'disabled':''}}"
              (click)="loadJobs(enumPage.Last)">
            <a class="next">
              {{ "BUTTON.LAST" | translate }}
              <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
